module.exports = __webpack_public_path__ + "img/marketplace.146a6e82.png";